export const API_BASE_URL =
  (typeof process !== "undefined" && process.env.REACT_APP_API_BASE_URL) ||
  "https://api.thaaiinteriors.com/api/v1/";
